import { render } from "./ShrImp.vue?vue&type=template&id=da533774"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/ShrImp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "da533774"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('da533774', __exports__)) {
    api.reload('da533774', __exports__)
  }
  
  module.hot.accept("./ShrImp.vue?vue&type=template&id=da533774", () => {
    api.rerender('da533774', render)
  })

}


export default __exports__